const REVIEW_OPTION_TYPES = [
  {
    id: 1,
    name: '키',
    search_options: [
      {
        name: '149 cm 이하',
        value: '-149'
      },
      {
        name: '150 - 154 cm',
        value: '150-154'
      },
      {
        name: '155 - 159 cm',
        value: '155-159'
      },
      {
        name: '160 - 164 cm',
        value: '160-164'
      },
      {
        name: '165 - 169 cm',
        value: '165-169'
      },
      {
        name: '170 - 174 cm',
        value: '170-174'
      },
      {
        name: '175 - 179 cm',
        value: '175-179'
      },
      {
        name: '180 - 184 cm',
        value: '180-184'
      },
      {
        name: '185 - 189 cm',
        value: '185-189'
      },
      {
        name: '190 cm 이상',
        value: '190'
      }
    ]
  },
  {
    id: 2,
    name: '몸무게',
    search_options: [
      {
        name: '44 kg 이하',
        value: '-44'
      },
      {
        name: '45 - 49 kg',
        value: '45-49'
      },
      {
        name: '50 - 54 kg',
        value: '50-54'
      },
      {
        name: '55 - 59 kg',
        value: '55-59'
      },
      {
        name: '60 - 64 kg',
        value: '60-64'
      },
      {
        name: '65 - 69 kg',
        value: '65-69'
      },
      {
        name: '70 - 74 kg',
        value: '70-74'
      },
      {
        name: '75 - 79 kg',
        value: '75-79'
      },
      {
        name: '80 - 84 kg',
        value: '80-84'
      },
      {
        name: '85 - 89 kg',
        value: '85-89'
      },
      {
        name: '90 - 94 kg',
        value: '90-94'
      },
      {
        name: '95 - 99 kg',
        value: '95-99'
      },
      {
        name: '100 kg 이상',
        value: '100'
      }
    ]
  },
  {
    id: 3,
    name: '평소 사이즈',
    search_options: [
      {
        name: 'S',
        value: 'S'
      },
      {
        name: 'M',
        value: 'M'
      },
      {
        name: 'L',
        value: 'L'
      }
    ]
  },
  {
    id: 4,
    name: '사이즈 어때요?',
    search_options: [
      {
        name: '많이 작아요',
        value: '많이 작아요'
      },
      {
        name: '조금 작아요',
        value: '조금 작아요'
      },
      {
        name: '잘 맞아요',
        value: '잘 맞아요'
      },
      {
        name: '조금 커요',
        value: '조금 커요'
      },
      {
        name: '많이 커요',
        value: '많이 커요'
      }
    ]
  },
  {
    id: 5,
    name: '마케팅 동의',
    search_options: [
      {
        name: 'Y',
        value: 'Y'
      },
      {
        name: 'N',
        value: 'N'
      }
    ]
  }
];

export default REVIEW_OPTION_TYPES;
